import { asSingleStyleConfig } from '../../utils/theme';
import { keyframes } from '../../system';
import { getColor } from '../../theme-tools';
var loading = () => keyframes({
  '0%': {
    transform: 'translateX(-100%)'
  },
  '60%': {
    transform: 'translateX(100%)'
  },
  '100%': {
    transform: 'translateX(100%)'
  }
});
var baseStyle = props => {
  var defaultLoaderColor = 'grey.100';
  var defaultSkeletonBgColor = 'grey.250';
  var {
    loaderColor = defaultLoaderColor,
    skeletonBgColor = defaultSkeletonBgColor,
    speed,
    theme
  } = props;
  var loader = getColor(theme, loaderColor);
  var background = getColor(theme, skeletonBgColor);
  return {
    position: 'relative',
    backgroundColor: background,
    borderRadius: '2px',
    overflow: 'hidden',
    _after: {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'absolute',
      bottom: 0,
      top: 0,
      left: 0,
      right: 0,
      background: "linear-gradient(90deg, transparent 0%, ".concat(loader, " 50%, transparent 100%);"),
      transform: 'translate(-100%)',
      animation: "".concat(speed, "s ").concat(loading(), " linear 0.5s infinite")
    }
  };
};
export default asSingleStyleConfig({
  baseStyle
});